import React from 'react';
import { useAppDispatch, useTypedSelector } from '@fiji/common';
import { setSchedulesForComponent } from '@fiji/common/src/features/component/schedule/scheduleSlice';

type ReturnProps = {
    viewMode: string;
    resetNodes: any;
    selectedDate: any;
    groupingEnabled: boolean;
};

export const useHandleSchedule = (callback?: any): ReturnProps => {
    const dispatch = useAppDispatch();

    const mode = useTypedSelector((state: any) => state['schedule']['mode']);
    const triggeredEvent = useTypedSelector((state) => state['schedule']['triggeredEvent']);
    const selectedDate = useTypedSelector((state: any) => state['schedule']['selectedDate']);
    const externalSignal = useTypedSelector((state) => state['schedule']['externalClickSignal']);
    const groupingEnabled = useTypedSelector((state: any) => state['schedule']['isGroupingEnabled']);

    const resetNodes = (): void => {
        dispatch(setSchedulesForComponent([]));
    };

    React.useEffect(() => {
        if (externalSignal && callback) {
            callback(triggeredEvent);
        }
    }, [externalSignal]);

    return {
        resetNodes,
        selectedDate,
        viewMode: mode,
        groupingEnabled: groupingEnabled,
    };
};
